import React from 'react'

// TODO: Get Bable to compile esm dependencies as CJS
// TODO: – or –
// TODO: Add rule that stops devs from importing ESM-only dependencies

/**
 * A React hook that uses useEffect() on the server and useLayoutEffect() in the browser
 * See https://www.npmjs.com/package/@react-hook/passive-layout-effect
 * This code was brought into our codebase to workaround a difficulty compiling ESM
 * dependencies to CJS using Babel
 */
const usePassiveLayoutEffect =
  React[
    // eslint-disable-next-line no-void
    typeof document !== 'undefined' && document.createElement !== void 0
      ? 'useLayoutEffect'
      : 'useEffect'
  ]

export default usePassiveLayoutEffect
